import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment, useMemo } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import H4 from 'UIComponents/elements/headings/H4';
import UIGrid from 'UIComponents/grid/UIGrid';
import UIGridItem from 'UIComponents/grid/UIGridItem';
import UISelectableButton from 'UIComponents/button/UISelectableButton';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { getServices } from '../../slices/serviceCatalogSlice';
/* @ts-expect-error module is untyped */

import { isQa } from '../../utils/env'; // width in pixels (from mocks)

const BUTTON_WIDTH = 242;
const relevantServiceIds = isQa() ? [1290, 1309, 1292] : [5, 24, 7]; // textKey: slug

const industriesButtons = {
  TECHNOLOGY_SOFTWARE: '/technology-software',
  BANKING_FINANCIAL_SERVICES: '/banking-financial-services',
  MARKETING_SERVICES: '/marketing-services'
};
const StyledUISelectableButton = styled(UISelectableButton).withConfig({
  displayName: "NoResultsState__StyledUISelectableButton",
  componentId: "jlv322-0"
})(["&&{max-width:", "px;width:", "px;height:48px;display:flex;align-items:center;}"], BUTTON_WIDTH, BUTTON_WIDTH);

const LinkButton = ({
  buttonText,
  to
}) => /*#__PURE__*/_jsx(UIRouterLink, {
  to: to,
  use: "unstyled",
  children: /*#__PURE__*/_jsx(StyledUISelectableButton, {
    className: "m-bottom-7",
    children: buttonText
  })
});

export default function NoResultsState({
  searchTerm
}) {
  const noResultsTextKey = searchTerm ? 'noResultsSearchTerm' : 'noResults';
  const services = useSelector(getServices);
  const renderedServicesButtons = useMemo(() => {
    return relevantServiceIds.map(serviceId => {
      const serviceObject = services.filter(service => {
        return service.id === serviceId;
      })[0];
      return serviceObject && /*#__PURE__*/_jsx(LinkButton, {
        buttonText: serviceObject.name,
        to: serviceObject.apiName
      }, serviceObject.apiName);
    });
  }, [services]);
  const renderedIndustriesButtons = useMemo(() => {
    return Object.keys(industriesButtons).map(textKey => /*#__PURE__*/_jsx(LinkButton, {
      buttonText: unescapedText(`marketplace-ui-common.industry.${textKey}.sentence`),
      to: industriesButtons[textKey]
    }, textKey));
  }, []);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(H4, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `ecosystem-marketplace-solutions-ui.storefront.results.noResultsEmptyState.${noResultsTextKey}`,
        options: {
          searchTerm
        }
      })
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `ecosystem-marketplace-solutions-ui.storefront.results.noResultsEmptyState.message`
      })
    }), /*#__PURE__*/_jsxs(UIGrid, {
      "data-test-id": "search-results-empty-state",
      className: "m-top-8 m-x-0",
      children: [/*#__PURE__*/_jsxs(UIGridItem, {
        className: "p-x-0",
        size: {
          sm: 12,
          md: 4
        },
        children: [/*#__PURE__*/_jsx(H4, {
          className: "m-bottom-7",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'ecosystem-marketplace-solutions-ui.storefront.results.noResultsEmptyState.servicesLabel'
          })
        }), renderedServicesButtons]
      }), /*#__PURE__*/_jsxs(UIGridItem, {
        className: "p-x-0",
        size: {
          sm: 12,
          md: 4
        },
        children: [/*#__PURE__*/_jsx(H4, {
          className: "m-bottom-7",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'ecosystem-marketplace-solutions-ui.storefront.results.noResultsEmptyState.industriesLabel'
          })
        }), renderedIndustriesButtons]
      })]
    })]
  });
}